/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown> }} Workout_Logging_Plates_TargetInputs */

const en_us2_workout_logging_plates_target = /** @type {(inputs: Workout_Logging_Plates_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} on the bar`)
};

const pt_br2_workout_logging_plates_target = /** @type {(inputs: Workout_Logging_Plates_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} na barra`)
};

const es_419_workout_logging_plates_target = /** @type {(inputs: Workout_Logging_Plates_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} en la barra`)
};

const pt_pt2_workout_logging_plates_target = /** @type {(inputs: Workout_Logging_Plates_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} na barra`)
};

const fr_fr2_workout_logging_plates_target = /** @type {(inputs: Workout_Logging_Plates_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} sur la barre`)
};

const de_de2_workout_logging_plates_target = /** @type {(inputs: Workout_Logging_Plates_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} auf der Stange`)
};

const it_it2_workout_logging_plates_target = /** @type {(inputs: Workout_Logging_Plates_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} sul bilanciere`)
};

/**
* | output |
* | --- |
* | "{loadText} on the bar" |
*
* @param {Workout_Logging_Plates_TargetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_plates_target = /** @type {((inputs: Workout_Logging_Plates_TargetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Plates_TargetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_plates_target(inputs)
	if (locale === "es-419") return es_419_workout_logging_plates_target(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_plates_target(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_plates_target(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_plates_target(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_plates_target(inputs)
	return en_us2_workout_logging_plates_target(inputs)
});
export { workout_logging_plates_target as "workout-logging.plates_target" }